/**
 * bop-api rejects account holder ids that are not exactly 36 characters. Exact-length
 * check only — deliberately NOT a UUID-format regex; the server validates nothing further.
 */
export const ACCOUNT_HOLDER_ID_LENGTH = 36;
